import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { deleteControlledProduct } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_PRODS.DELETE,
  api: deleteControlledProduct,
  responseType: RESPONSETYPE.EMPTY
})



// WEBPACK FOOTER //
// ./src/actions/controlledProducts/DeleteAction.js